module.exports = __webpack_public_path__ + "img/gift-certificate.399ed909.png";